module.exports = __webpack_public_path__ + "static/img/TC.82edad8d.svg";